import type { FunnelData as BaseFunnelData } from "@huub-web/shared";

/**
 * Extended funnel data for the vite app with additional tracking properties
 */
export type FunnelData = Omit<BaseFunnelData, "addressObjectID"> & {
  /** Address object ID - allows null for explicit unset */
  addressObjectID?: string | null;
  /** Whether this is a follow-up session */
  __followUp: boolean;
};

export const FUNNEL_DATA_KEY = "funnelData";
